import { Link, useParams } from "react-router-dom";
import { APP_ROUTES } from "../../routes";

export default function EdgeOverview() {
  const { id: projectId = "" } = useParams<{ id: string }>();

  return (
    <div className="manifold-page">
      <header className="manifold-page-header">
        <p className="sg-section-kicker">Pillar C · Edge Reflex Core</p>
        <h1>Edge Reflex</h1>
        <p className="text-muted">
          Live telemetry from the safety loop running alongside each
          robot controller. Reports impedance state, contact-force events,
          watchdog dips, and any HyperCompliantDefensiveYield activations.
        </p>
      </header>

      <section className="manifold-empty">
        <h2>No edge-reflex daemons connected</h2>
        <p>
          Each deployment pairs with one reflex loop. Connect a
          robot from the Deployment view to begin streaming sub-0.5&nbsp;ms
          loop telemetry through robot-bridge.
        </p>
        <div className="sg-hero-actions">
          <Link to={APP_ROUTES.deploy(projectId)} className="sg-btn sg-btn-primary">
            Open deployments
          </Link>
          <Link to={APP_ROUTES.project(projectId)} className="sg-btn sg-btn-secondary">
            Back to project
          </Link>
        </div>
      </section>
    </div>
  );
}
